import { render, staticRenderFns } from "./SearchBar.vue?vue&type=template&id=452481ea&scoped=true"
import script from "./SearchBar.ts?vue&type=script&lang=ts&external"
export * from "./SearchBar.ts?vue&type=script&lang=ts&external"
import style0 from "./SearchBar.scss?vue&type=style&index=0&id=452481ea&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452481ea",
  null
  
)

export default component.exports